import { render, staticRenderFns } from "./rightTotal.vue?vue&type=template&id=6c516314&scoped=true&"
import script from "./rightTotal.vue?vue&type=script&lang=js&"
export * from "./rightTotal.vue?vue&type=script&lang=js&"
import style0 from "./rightTotal.vue?vue&type=style&index=0&id=6c516314&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c516314",
  null
  
)

export default component.exports